<div class="container-fluid">
    <div class="row pt-4 pl-4" style="font-size: 22px !important;
    font-weight: 400;
    color: #424242;">
      <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;My Target Report</h5>
    </div>

    <div id="mainContent" class="container">
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-5">
              <div class="row">
                <label class="col-sm-4 col-form-label"
                  >Financial Year<span class="text-danger">*</span></label
                >
                <div class="col-sm-6">
                  <select
                    class="form-control form-control-xs mt-1"
                    [(ngModel)]="selectedFinancialYear"
                    (change)="onFinancialYearSlected()"
                  >
                    <option value="">Select Year</option>
                    <option *ngFor="let finance of financialList" [ngValue]="finance">
                      {{ finance.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <!-- <div class="col-sm-5">
                <div class="row">
                  <label class="col-sm-4 col-form-label"
                    >Partner<span class="text-danger">*</span></label
                  >
                  <div class="col-sm-6">
                    <select
                      class="form-control form-control-xs mt-1"
                      [(ngModel)]="selectedPartner"
                      (change)="onPartnerSelected()"
                    >
                      <option value="">Select Partner</option>
                      <option *ngFor="let partner of partnerList" [ngValue]="partner">
                        {{ partner.firstName }} {{partner.lastName}}
                      </option>
                    </select>
                  </div>
                </div>
              </div> -->
     
              <div class="col-sm-5">
                <div class="row">
                  <label class="col-sm-4 col-form-label"
                    >Client<span class="text-danger">*</span></label
                  >
                  <div class="col-sm-6">
                    <mat-form-field appearance="legacy" style="width: 100%">
                      <mat-select
                        multiple
                        [(ngModel)]="selectedClient"
                        #designateClientName="ngModel"
                      >
                        <mat-option
                          (click)="selectAllClient(designateClientName, clientList)"
                          [value]="0"
                          >Select All
                        </mat-option>
                        <mat-option
                          #item
                          *ngFor="let client of clientList"
                          [value]="client"
                        >
                          {{ client.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
    
            </div>

     <div class="row">
          <div class="col-sm-2">
            <button
              type="button"
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="onViewReport()"
            >
              View Report
            </button>
          </div>
          <!-- <div class="col-sm-2">
            <button
              type="button"
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="onExportToExcelReport()"
            >
              Export To Excel
            </button>
          </div> -->
     </div>
    </div>
</div>
<br>
<div class="container" id="mainContent">
  <div id="elementsForPDF" *ngIf="reportList">
    <div class="row justify-content-center text-center pt-3">
      <span class="bg-theme-title"
        >P G BHAGWAT LLP, Chartered Accountants
      </span>
    </div>
    <div class="row justify-content-center text-center ">
      <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
    </div>


    <div class="row justify-content-center text-center mt-2">
        <span class="bg-theme-title"
          >My Target</span>
    </div>
    <div class="row justify-content-center text-center">
        <span class="bg-theme-title"
          >AsgForFY : {{ selectedFinancialYear.name }}</span
        >
    </div>
    <div class="pt-2 pb-2">
      <table class="table table-bordered table-sm table-striped"> 
        <thead>
          <tr>
            <th>Client Name</th>
             <th>Assignments</th>
            <th>Actual Days</th>
            <th>Budgeted Days</th>
          </tr>
        </thead>
        <tbody>

        </tbody>
        <tbody>
          <ng-container *ngFor="let clientDetails of reportList.clients;let clientIndex=index;let clientCount=count;">
          <ng-container *ngFor="let assignmentDetail of clientDetails.assignments;let assignmentIndex=index;let assignmentCount=count;">
            <tr *ngIf="assignmentIndex==0">
             <td [attr.rowspan]="assignmentCount">{{clientDetails.client}}</td>
             <td>{{assignmentDetail.assignment}}</td>
             <td>{{assignmentDetail.days.actualDays}}</td>             
             <td>{{assignmentDetail.days.targetDays}}</td>
            </tr>
            <tr *ngIf="assignmentIndex!=0">
              <td>{{assignmentDetail.assignment}}</td>
              <td>{{assignmentDetail.days.actualDays}}</td>             
              <td>{{assignmentDetail.days.targetDays}}</td>
             </tr>
          </ng-container>
          </ng-container>
        </tbody>     
      </table>
    </div>
  </div>
  </div>
</div>